import { useDispatch, useSelector } from 'react-redux'
import storeInfo, { RootState, AppDispatch } from './store'

// Typed hooks for Redux 5 compatibility
export const useAppDispatch = () => useDispatch<AppDispatch>()
export const useAppSelector = <T>(selector: (state: RootState) => T): T => useSelector(selector)

// Helper to get typed state from store (for use in selectors)
export const getTypedState = (): RootState => storeInfo.store.getState() as RootState
